import React, { useState } from 'react';

import { ExecutionStatusSelect } from '@qality/common-components/src/select/execution-status-select/ExecutionStatusSelect';
import { ExecutionStatus, TestCaseInCycle } from '@qality/common-model';

import { useTestCasesInCycleList } from '../TestCaseInCycleListProvider';
import { handleExecutionStatusChange } from '../TestCasesInCycleTableBody/TestCaseInCycleTableRow/TestCaseInCycleTableRow.util';

type Props = {
  testCaseInCycle: TestCaseInCycle;
};

export function TestCasesInCycleExecutionStatusSelect({
  testCaseInCycle,
}: Props): JSX.Element {
  const { executionStatuses, testCycleActions, testCycle } =
    useTestCasesInCycleList();
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (newExecutionStatus: ExecutionStatus) => {
    setIsLoading(true);
    await handleExecutionStatusChange(
      testCaseInCycle,
      newExecutionStatus,
      testCycleActions.updateTestCycle,
      testCycle
    );
    setIsLoading(false);
  };

  return (
    <ExecutionStatusSelect
      value={testCaseInCycle.statusDetail}
      statuses={executionStatuses.allStatuses}
      onChange={handleChange}
      isLoading={isLoading}
    />
  );
}
